import { ActionTypes } from './constants';

export const reducer = (state = {}, action = {}) => {
    if (action.type === ActionTypes.IS_HTTPS) {
        return {
            ...state,
            isHttps: action.payload,
        };
    }

    if (action.type === ActionTypes.FETCH_METRICS) {
        return {
            ...state,
            metrics: action.payload,
        };
    }

    return state;
};
